"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
var react_1 = __importStar(require("react"));
var toggleSwitch_1 = require("../../../constants/atoms/toggleSwitch");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var TOGGLE_SWITCH_STYLES = (_a = {},
    _a[toggleSwitch_1.TOGGLE_SWITCH_TYPES.SELECTED] = (_b = {},
        _b[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.ENABLED] = 'tw-bg-TEXT_PRIMARY tw-box-content tw-border-[0.5px] tw-border-TEXT_PRIMARY',
        _b[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.HOVER] = '',
        _b[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.DISABLED] = 'tw-bg-TEXT_TERTIARY tw-cursor-not-allowed',
        _b),
    _a[toggleSwitch_1.TOGGLE_SWITCH_TYPES.UNSELECTED] = (_c = {},
        _c[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.ENABLED] = 'tw-bg-DIVIDER_GRAY tw-box-content tw-border-DIVIDER_GRAY',
        _c[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.HOVER] = ' tw-border-[0.5px] hover:tw-border-TEXT_PRIMARY',
        _c[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.DISABLED] = 'tw-bg-TEXT_TERTIARY tw-cursor-not-allowed',
        _c),
    _a);
var TOGGLE_SWITCH_SLIDER = (_d = {},
    _d[toggleSwitch_1.TOGGLE_SWITCH_TYPES.SELECTED] = (_e = {},
        _e[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.ENABLED] = 'tw-right-[3px] tw-bg-white',
        _e[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.DISABLED] = 'tw-bg-DIVIDER_GRAY tw-right-[3px]',
        _e),
    _d[toggleSwitch_1.TOGGLE_SWITCH_TYPES.UNSELECTED] = (_f = {},
        _f[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.ENABLED] = 'tw-left-[3px] tw-bg-white',
        _f[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.DISABLED] = 'tw-bg-DIVIDER_GRAY tw-left-[3px]',
        _f),
    _d);
var ToggleSwitch = function (_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, onChange = _a.onChange, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.toggleClassName, toggleClassName = _e === void 0 ? 'tw-relative tw-outline-none tw-h-5 tw-w-9 tw-rounded-full tw-transition-all tw-duration-200' : _e, _f = _a.sliderClassName, sliderClassName = _f === void 0 ? 'tw-absolute tw-top-[3px] tw-rounded-full tw-w-3.5 tw-h-3.5  tw-transition-all tw-duration-200' : _f, _g = _a.sliderStyle, sliderStyle = _g === void 0 ? '' : _g, _h = _a.toggleStyle, toggleStyle = _h === void 0 ? '' : _h, _j = _a.wrapperClassName, wrapperClassName = _j === void 0 ? '' : _j, _k = _a.labelClassName, labelClassName = _k === void 0 ? '' : _k, eventCallback = _a.eventCallback, id = _a.id;
    var _l = react_1.useState(checked), active = _l[0], setActive = _l[1];
    react_1.useEffect(function () {
        setActive(checked);
    }, [checked]);
    var toggle = function () {
        if (disabled)
            return;
        setActive(!active);
        onChange(!active);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.CHECKBOX_CHANGE, { id: id, checked: !checked });
    };
    var stateStyles = active
        ? TOGGLE_SWITCH_STYLES[toggleSwitch_1.TOGGLE_SWITCH_TYPES.SELECTED]
        : TOGGLE_SWITCH_STYLES[toggleSwitch_1.TOGGLE_SWITCH_TYPES.UNSELECTED];
    var sliderStyles = active
        ? TOGGLE_SWITCH_SLIDER[toggleSwitch_1.TOGGLE_SWITCH_TYPES.SELECTED]
        : TOGGLE_SWITCH_SLIDER[toggleSwitch_1.TOGGLE_SWITCH_TYPES.UNSELECTED];
    var toggleSwitchStylesByState = disabled
        ? stateStyles[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.DISABLED]
        : stateStyles[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.ENABLED] + " " + stateStyles[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.HOVER];
    var toggleSwitchSliderStylesByState = disabled
        ? sliderStyles[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.DISABLED]
        : sliderStyles[toggleSwitch_1.TOGGLE_SWITCH_STATE_TYPES.ENABLED] + " ";
    return (react_1.default.createElement("div", { className: "" + wrapperClassName, "data-testid": "toggle-switch-wrapper-" + id },
        react_1.default.createElement("button", { role: 'switch', "aria-checked": active, className: " " + toggleSwitchStylesByState + " " + toggleClassName + " " + toggleStyle, onClick: toggle, "data-testid": "toggle-switch-btn-" + id },
            react_1.default.createElement("span", { className: sliderClassName + " " + sliderStyle + " " + toggleSwitchSliderStylesByState, "data-testid": "toggle-switch-slider-" + id })),
        label && (react_1.default.createElement("label", { className: labelClassName, "data-testid": "toggle-switch-label-" + id }, label))));
};
exports.ToggleSwitch = ToggleSwitch;
